// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UseCategoryDisplayPriority$Showside from "./UseCategoryDisplayPriority.bs.js";
function useIsPLP(param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var routerProvider = RouterProvider$Showside.useRouter(undefined);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */1;
  var match$1 = routerProvider.listPageType;
  var isProductsView = match$1 !== undefined && (typeof match$1 === "number" || match$1.TAG !== /* Category */0) ? true : false;
  return React.useMemo(function () {
    if (activeCategory !== undefined) {
      if (Category$Showside.hasProducts(activeCategory) || Category$Showside.Link.isStoreCategoryLink(activeCategory)) {
        if (Category$Showside.hasSubCategories(activeCategory)) {
          return isForcingPLP;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else if (Belt_Option.isSome(Belt_Option.flatMap(config.settings.indexNode, function (category) {
      return Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
    })) && (Belt_Option.isSome(routerProvider.productFilters) || isForcingPLP)) {
      return true;
    } else {
      return isProductsView;
    }
  }, [activeCategory, isForcingPLP, config.settings.indexNode, routerProvider]);
}
export { useIsPLP };
/* react Not a pure module */